// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3IQNj","productName":"Table_productName__1Bo72"};